export const BASE_WEBSOCKET = process.env.REACT_APP_BASE_URL;

const WEBSOCKETS = {
  chatGroupWS: (nurseryId, chatGroupName, accessToken) => `${BASE_WEBSOCKET}/ws/nursery/${nurseryId}/chat-group/${chatGroupName}/?jwt_token=${accessToken}`,
  inboxWS: (nurseryId, accessToken) => `${BASE_WEBSOCKET}/ws/nursery/${nurseryId}/chat-inbox/?jwt_token=${accessToken}`,
};

export default WEBSOCKETS;
